import * as React from "react";
import { useEffect, useState } from "react";
import Box from "./parts/Box";
import ExtLink from "./parts/ExtLink";
import { ll_url } from "./utils/tools";
import { extraJobs, extraVisitors, toolEmail, toolPublication } from "./settings";
import { AppApi } from "./api";
import { AppState } from "./api/openapi-generator";

export function Sidebar() {

  const [state, setState] = useState<AppState>();
  useEffect(() => {
    AppApi.state().then(state => setState(state));
  }, []);
  const visitors = state && typeof state.visitors === 'number' ? state.visitors + extraVisitors : undefined;
  const jobs = state ? state.jobs + extraJobs : undefined;
  
  return <>
    <Box title="References" intro>
      <p style={{ marginBottom: '0' }}>
        {toolPublication.authors}, {toolPublication.year}: {toolPublication.title}. <em>{toolPublication.journal}</em>.
      </p>
      <div className="ll-references" style={{marginTop: '0.5rem'}}>
        <ExtLink to={toolPublication.pubmedLink}>
          <img src={ll_url('/images/logos/pubmed.svg')} alt="PubMed" className="ll-pubmed-icon"/>
        </ExtLink>
        <ExtLink to={toolPublication.doiLink}>
          <img src={ll_url('/images/logos/open_access.svg')} alt="Open Access" className="ll-open-access-icon"/>
        </ExtLink>
      </div>
    </Box>

    <Box title="User statistics" intro>
      <ul>
        <li>
          <strong>Number of visitors:</strong> {visitors ?? '-'}
        </li>
        <li>
          <strong>Number of jobs:</strong> {jobs ?? '-'}
        </li>
      </ul>
    </Box>

    <Box title="Contact" intro>
      <p className="ll-contact">Loschmidt Laboratories</p>
      <ul>
        <li>
          <a href={`mailto:${toolEmail}`}>{toolEmail}</a>
        </li>
        <li>
          <ExtLink to="https://loschmidt.chemi.muni.cz/" />
        </li>
      </ul>
    </Box>

    <Box title="Other tools" intro contentClassName="ll-other-tools">
      <ExtLink to="https://loschmidt.chemi.muni.cz/enzymeminer/" className="ll-enzymeminer">
        <img src={ll_url('/images/logos/enzymeminer.svg')} />
      </ExtLink>
      <ExtLink to="https://loschmidt.chemi.muni.cz/soluprot/" className="ll-soluprot">
        <img src={ll_url('/images/logos/soluprot.svg')} />
      </ExtLink>
      <ExtLink to="https://loschmidt.chemi.muni.cz/predictsnp/" className="ll-predictsnp">
        <img src={ll_url('/images/logos/predictsnp.svg')} />
      </ExtLink>
      <ExtLink to="https://loschmidt.chemi.muni.cz/caverweb/" className="ll-caver">
        <img src={ll_url('/images/logos/caverweb.svg')} />
      </ExtLink>
      <ExtLink to="https://loschmidt.chemi.muni.cz/fireprot/" className="ll-fireprot">
        <img src={ll_url('/images/logos/fireprot.svg')} />
      </ExtLink>
      <ExtLink to="https://loschmidt.chemi.muni.cz/hotspotwizard/" className="ll-hotspotwizard">
        <img src={ll_url('/images/logos/hotspotwizard.svg')} />
      </ExtLink>
      <ExtLink to="https://loschmidt.chemi.muni.cz/calfitter/" className="ll-calfitter">
        <img src={ll_url('/images/logos/calfitter.svg')} />
      </ExtLink>
    </Box>

    <Box title="Acknowledgement">
      <div className="ll-ack-logos">
        <ExtLink to="https://czecrin.cz/en/home/" className="ll-czecrin">
          <img src={ll_url('/images/logos/czecrin-400px.jpg')} />
        </ExtLink>
      </div>
    </Box>
  </>
  
}